import React, { useState, useEffect, useRef } from "react";
import "../styles/Header.css";
import logo from "../assets/logo.png";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const lastScrollY = useRef(0);

  const navRef = useRef(null); // ✅ Added for outside click

  const navigate = useNavigate();
  const location = useLocation();

  /* ------------------------------------------------------------------
     SAFE hover handler
  ------------------------------------------------------------------ */
  const handleMove = (e) => {
    const btn = e.currentTarget;
    const circle = btn?.querySelector?.(".hover-circle");

    if (!circle) return;

    const rect = btn.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const x = clientX - rect.left;
    const y = clientY - rect.top;

    circle.style.left = `${x}px`;
    circle.style.top = `${y}px`;
  };

  /* Smooth scroll + close menu */
  const scrollToSection = (id) => {
    setOpen(false);

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  /* Navigation + close menu */
  const goToPage = (path) => {
    setOpen(false);
    navigate(path);
  };

  /* Hide header on scroll */
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ✅ Close menu when clicking outside */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        open &&
        navRef.current &&
        !navRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [open]);

  return (
    <header className={`h-header ${showHeader ? "show" : "hide"}`}>
      
      {/* LOGO */}
      <div
        className="h-header-logo"
        onClick={() => goToPage("/")}
        style={{ cursor: "pointer" }}
      >
        <img src={logo} alt="luxury tempo traveller hire in mayiladuthurai" />
      </div>

      {/* HAMBURGER */}
      <label className="h-hamburger">
        <input
          type="checkbox"
          checked={open}
          onChange={() => setOpen(!open)}
        />
        <svg viewBox="0 0 32 32">
          <path
            className="h-line h-line-top-bottom"
            d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
          />
          <path className="h-line" d="M7 16 27 16" />
        </svg>
      </label>

      {/* NAV MENU */}
      <div
        ref={navRef}
        className={`h-navbar-container ${open ? "active" : ""}`}
      >
        <ul>
          <li
            style={{ "--i": "#ffb703", "--j": "#ff8000" }}
            onClick={() => scrollToSection("home")}
          >
            <span className="h-icon">
              <ion-icon name="home-outline"></ion-icon>
            </span>
            <span className="h-title">Home</span>
          </li>

          <li
            style={{ "--i": "#ffb703", "--j": "#ffa500" }}
            onClick={() => scrollToSection("about")}
          >
            <span className="h-icon">
              <ion-icon name="information-circle-outline"></ion-icon>
            </span>
            <span className="h-title">About</span>
          </li>

          <li
            style={{ "--i": "#ffb703", "--j": "#ff7f50" }}
            onClick={() => scrollToSection("services")}
          >
            <span className="h-icon">
              <ion-icon name="car-outline"></ion-icon>
            </span>
            <span className="h-title">Services</span>
          </li>

          <li
            style={{ "--i": "#ffb703", "--j": "#ff6347" }}
            onClick={() => scrollToSection("contact")}
          >
            <span className="h-icon">
              <ion-icon name="call-outline"></ion-icon>
            </span>
            <span className="h-title">Contact</span>
          </li>

          <li
            style={{ "--i": "#ffb703", "--j": "#ff4500" }}
            onClick={() => goToPage("/gallery")}
          >
            <span className="h-icon">
              <ion-icon name="images-outline"></ion-icon>
            </span>
            <span className="h-title">Gallery</span>
          </li>

          <li
            style={{ "--i": "#ffb703", "--j": "#ff4500" }}
            onClick={() => goToPage("/blog")}
          >
            <span className="h-icon">
              <ion-icon name="document-text-outline"></ion-icon>
            </span>
            <span className="h-title">Blog</span>
          </li>
        </ul>

        {/* MOBILE CALL BUTTON */}
        <div className="h-mobile-call">
          <a
            href="tel:+919486589488"
            className="h-call-btn btn-6"
            onMouseMove={handleMove}
            onTouchMove={handleMove}
          >
            <span className="hover-circle"></span>
            <span className="h-call-icon">📞</span>

            <div className="h-call-text">
              <small>Call Anytime</small>
              <strong>+91 9486589488</strong>
            </div>
          </a>
        </div>
      </div>

      {/* DESKTOP CALL BUTTON */}
      <div className="h-header-call">
        <a
          href="tel:+919486589488"
          className="h-call-btn btn-6"
          onMouseMove={handleMove}
          onTouchMove={handleMove}
        >
          <span className="hover-circle"></span>
          <span className="h-call-icon">📞</span>

          <div className="h-call-text">
            <small>Call Anytime</small>
            <strong>+91 9486589488</strong>
          </div>
        </a>
      </div>
    </header>
  );
};

export default Header;